<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="템플릿 주문 내역"
      desc=""
    ></admin-filter>

    <!-- 탭 2 -->
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <!-- 날짜 -->
      <div slot="created_time" slot-scope="props">{{ props.item.created_time }}</div>

      <!-- 주문자 -->
      <div slot="user_name" slot-scope="props">{{ props.item.user.name }}</div>

      <!-- 파트너명 -->
      <div slot="partner" slot-scope="props" class="link"
        @click="clickPartner(props.item.order_product.product.partner)">{{ props.item.order_product.product.partner.name }}</div>
      <!-- 주문 상품 -->
      <div slot="order_product" slot-scope="props">
        <div class="link" @click="clickProduct(props.item.order_product.product)">{{ props.item.order_product.product.name }}</div>
      </div>
      <div slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</div>

      <!-- 결제 방법 -->
      <div slot="pay_type" slot-scope="props">빌링 결제</div>

      <!-- 일괄 처리 -->
      <!--<div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
        </div>
      </div>-->
    </admin-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(900)">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ListMixin from "@/mixins/ListMixin"

  export default {
    name: 'TemplatesAll',
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    data() {
      return {}
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('templates_order', 'launchpack/v1/templates/order');
      },
      getDataFromServer() {
        this.getData();
      },
      clickPartner(partner) {
        this.routerPush(this.getPath(`partner/create?id=${partner.id}`));
      },
      clickProduct(product) {
        this.routerPush(this.getPath(`product/create?id=${product.id}`));
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .admin-table td > div
    -webkit-line-clamp unset
    text-overflow unset

  .line-divide
    border-bottom 1px solid #dbdbdb
    margin-bottom 12px
    padding-bottom 12px

  .line-divide:last-child
    border-bottom 0
    margin-bottom 0
    padding-bottom 0

  .link
    text-decoration underline
  .link:hover
    color #ff5722
    cursor pointer
</style>
